import { type IStage, movSitesV2 } from '@metservicedev/platforms-services-interface';

const deleteSite = async (stage: IStage, movSiteId: string, metjwt: string, headers: any): Promise<any> => {
    try {
        const response = await movSitesV2.http.delete({
            token: metjwt,
            stage: stage,
            movSiteId: movSiteId,
            headers,
        });
        return response;
    } catch (err) {
        console.error(err);
    }
};

export default deleteSite;
